module.exports = __webpack_public_path__ + "img/cc-discover.7b5cdc97.svg";